import { render, staticRenderFns } from "./orgChange.vue?vue&type=template&id=d181bb1e&scoped=true&"
import script from "./orgChange.vue?vue&type=script&lang=js&"
export * from "./orgChange.vue?vue&type=script&lang=js&"
import style0 from "./orgChange.vue?vue&type=style&index=0&id=d181bb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d181bb1e",
  null
  
)

export default component.exports